export default __webpack_public_path__ + "static/media/cp_geo_nf.d3f4a2c0.svg";